import { createContext, ReactNode, useMemo, useState } from 'react';

interface ModalProviderProps {
  children: ReactNode;
}

interface ModalContextType {
  isModalOpen: boolean;
  setIsModalOpen: (isOpen: boolean) => void;
}

const initialState: ModalContextType = {
  isModalOpen: false,
  setIsModalOpen: () => {},
};

const ModalContext = createContext<ModalContextType>(initialState);

export const ModalProvider = ({ children }: ModalProviderProps) => {
  const [isModalOpen, setIsModalOpen] = useState(initialState.isModalOpen);
  const value = useMemo(
    () => ({
      isModalOpen,
      setIsModalOpen,
    }),
    [isModalOpen],
  );

  return <ModalContext.Provider value={value}>{children}</ModalContext.Provider>;
};

export default ModalContext;
